module.exports = __webpack_public_path__ + "img/product-1.59a4e8ca.png";